import moment from "moment";
import React from "react";
import toast from "react-hot-toast";
import { useAuth } from "react-oidc-context";
import { Button } from "../../../components";
import { DateInput } from "../../../components/forms";
import { useBuildAllClientValuationsMutation, usePersistAllClientValuationsBuildMutation } from "../../../services/valuations";
import { useAssetsUnderAdvice } from "../hooks/AssetsUnderAdviceContext";
import ValuationBuildSelect from "./ValuationBuildSelect";
import { openValuationDateConfirmationModal } from "./ValuationDateConfirmModal";
import classNames from "classnames";

export const ValuationDatePicker = ({ value, setValue }) => (
    <DateInput
        label={"Valuation Date"}
        value={value}
        onBlur={(date) => setValue(date)}
        maxDate={new Date()}
        disableAnimations
    />
);

const ValuationBuildPicker = () => {
    const { valuationDate, setValuationDate, buildId, isPersistent, setBuild } = useAssetsUnderAdvice();

    // Retrieve user name for passing to cache on build start
    const auth = useAuth();
    const { user: { profile: { name: userName } } } = auth;
    const [buildTrigger] = useBuildAllClientValuationsMutation();
    const [persistTrigger] = usePersistAllClientValuationsBuildMutation();

    const build = (selectedDate) =>
        toast.promise(buildTrigger({ valuationDate: selectedDate, userName }).unwrap(), {
            loading: "Building...",
            success: "Build created. You will be notified when it is finished.",
            error: (error) => `Failed to create build: ${error?.data} `
        });

    const persist = () =>
        toast.promise(persistTrigger({ valuationDate, buildId }).unwrap(), {
            loading: "Saving...",
            success: "Build saved. You will now be able to view this build in future.",
            error: (error) => `Failed to save build: ${error?.data} `
        });

    const onSelectBuild = (selection = null) => {
        if (selection == null)
            return setBuild(null);

        if (selection.value === -1) {
            openValuationDateConfirmationModal(moment()).then((r) => build(r));
        }

        setBuild(selection.data);
    };

    return <React.Fragment>
        <div className={"d-flex row gx-2"}>
            <span className="col-4">
                <ValuationDatePicker
                    value={valuationDate}
                    setValue={setValuationDate}
                />
            </span>
            <span className={classNames("mt-auto", {
                "col-8": isPersistent || buildId == null,
                "col-6": !isPersistent && buildId != null
            })}>
                <ValuationBuildSelect
                    label="Select Build"
                    valuationDate={valuationDate}
                    buildId={buildId}
                    onSelectBuild={onSelectBuild}
                    placeholder="Select/Commence a Valuation Build"
                    defaultMostRecent
                    disableAnimations
                />
            </span>
            {!isPersistent && buildId &&
                <span className="col-2 mt-auto">
                    <Button variant="success" onClick={persist}>
                        Save Build
                    </Button>
                </span>
            }
        </div>
    </React.Fragment>
}

export default ValuationBuildPicker;